import React, { useContext } from 'react'
import UserContext from '@context/UserContext'
import UseWindowSize from '@components/helpers/UseWindowSize'
import SoftButton from '@components/common/SoftButton'
import { ArrowRight } from '@phosphor-icons/react'

// assets
import fadedBg from '@images/BeachClub/landing-page/bbbc-landing-faded-bg.webp'
import fadedBgTablet from '@images/BeachClub/landing-page/bbbc-landing-faded-bg-tablet.webp'
import fadedBgMobile from '@images/BeachClub/landing-page/bbbc-landing-faded-bg-mobile.webp'

const HeroIntro = ({handleLoginModal}) => {
	const { width } = UseWindowSize()
	const { isLoggedIn, toggleAccountMenu } = useContext(UserContext)
	
	return (
		<React.Fragment>
			<div className={`relative min-h-[392px] lg:min-h-[488px] py-4 flex items-center justify-center overflow-hidden`}>
				<div className='absolute top-0 left-0 hero-faded-bg w-full'>
					{(width && width < 640) ? (<>
						<img src={fadedBgMobile} alt='Earn BB Bucks and redeem them for exclusive discounts, merchandise, and even swim!' />
					</>) : (width && width < 768) ? (<>
						<img src={fadedBgTablet} alt='Earn BB Bucks and redeem them for exclusive discounts, merchandise, and even swim!' />
					</>) : (<>
						<img src={fadedBg} alt='Earn BB Bucks and redeem them for exclusive discounts, merchandise, and even swim!' />
					</>)}
				</div>
				<div className='relative h-full px-6 space-y-4 text-center z-[2]'>
					<p className='text-[#3D3D3D] text-2xl md:text-4xl lg:text-5xl'>
						Earn BB Bucks and redeem them for exclusive discounts, merchandise, and even swim!
					</p>
					<p className='text-[#5D5D5D] text-md md:text-lg'>
						Trade them in for exclusive prizes -- from  discounts to bikinis
					</p>
					<SoftButton
						className={'btn-primary w-[197px] justify-center mx-auto mb-28 md:mb-20 lg:mb-40'}
						icon={<ArrowRight size={20} weight='light' />}
						ariaLabel={isLoggedIn ? 'Go to My Account' : 'Join Now'}
						label={isLoggedIn ? 'Go to My Account' : 'Join Now'}
						onClick={() => {
							if(isLoggedIn) toggleAccountMenu()
							else handleLoginModal(true)
						}}
					/>
				</div>
			</div>
		</React.Fragment>
	)
}

export default HeroIntro